"use client";

import { useAuthStore } from "@/store/auth";
import { ActiveStoreSelector } from "@/components/dashboard/ActiveStoreSelector";
import { StoreMiniView } from "@/components/dashboard/StoreMiniView";
import { GapAnalysisCard } from "@/components/dashboard/GapAnalysisCard";
import { NeighborhoodCard } from "@/components/dashboard/NeighborhoodCard";

/**
 * 내 매장 중심 분석 그룹 (사용자 결정 2026-05-10).
 *
 * 대분류 1개 안에 매장 selector + 3 중분류 (매출 요약·갭 분석·동네 레이더) 묶음.
 * 매장 selector 변경 시 3 카드 모두 동시 갱신 → 하나의 단위로 인지하기 쉬움.
 *
 * 비로그인·매장 미등록도 lock 상태로 노출 (각 자식이 자체 분기) → 가입 동기 유지.
 */
export function MyStoreGroupSection() {
  const hasHydrated = useAuthStore((s) => s._hasHydrated);

  if (!hasHydrated) return null;

  return (
    <section className="px-4 mt-6">
      <div className="flex items-center justify-between mb-3">
        <h2 className="section-title-major mb-0">🏪 내 매장 중심 분석</h2>
      </div>

      {/* 외곽 라인 — primary 톤으로 차별화 (사용자 결정 2026-05-10) — 안 카드들과 구분 명확
          5/11 후속 — sub-section 헤더가 외곽 테두리 위에 거의 닿도록 padding 최소화.
          - wrapper: px-3 (좌우 12px), py-2 (위아래 8px) — 옛 p-3 (12px) 보다 줄임
          - section-title: mb-2 + mt-1 (헤더 외곽선 가까이 + 본문과의 간격 유지) */}
      <div className="rounded-2xl border-2 border-primary/30 bg-bg-card/40 px-3 py-2
                      [&_.section-title]:mb-2 [&_.section-title]:mt-1 space-y-2">
        {/* 매장 selector — ≥2 매장일 때만 자체 노출 (1개 이하 = null) */}
        <ActiveStoreSelector inline />

        {/* 중분류 3 — 매출 요약 / 갭 분석 / 동네 레이더
            min-h 로 CLS 방지 (사용자 결정 2026-05-14) — 로딩 → 데이터 도착 시 화면 점프 차단 */}
        <div className="space-y-2 [&>*+*]:pt-2 [&>*+*]:border-t [&>*+*]:border-border/50">
          <div className="min-h-[140px]"><StoreMiniView compact /></div>
          <div className="min-h-[120px]"><GapAnalysisCard compact /></div>
          <div className="min-h-[120px]"><NeighborhoodCard compact /></div>
        </div>
      </div>
    </section>
  );
}
